/* --------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

//import _ from 'lodash';
import service from '../../services/wordspotting';
import _ from 'lodash';

const WORDSPOTTING_ALL = 'WORDSPOTTING_ALL';
const WORDSPOTTING_DELETE = 'WORDSPOTTING_DELETE';
const WORDSPOTTING_ADD = 'WORDSPOTTING_ADD';

const state = {
  list: {
    global: {},
    org: {},
    groups: {},
    user: {}
  }
};

const mutations = {
  [WORDSPOTTING_ALL] (state, wordspotting) {
    state.list.global = wordspotting.global;
    state.list.org = wordspotting.org;
    state.list.groups = wordspotting.groups;
    state.list.user = wordspotting.user;
  },
  [WORDSPOTTING_DELETE] (state, data) {
    if (data.orgId) {
      delete state.list.org[data.algorithm];
    } else if (data.groupId) {
      delete state.list.groups[data.groupId][data.algorithm];
    } else {
      delete state.list.user[data.algorithm];
    }
  },
  [WORDSPOTTING_ADD] (state, data) {
    if (data.orgId) {
      _.assign(state.list.org[data.algorithm], data);
    } else if (data.groupId) {
      if (!(data.groupId in state.list.groups)) {
        state.list.groups[data.groupId] = {};
      }
      _.assign(state.list.groups[data.groupId][data.algorithm], data);
    } else {
      _.assign(state.list.user[data.algorithm], data);
    }
  },
};

const actions = {
  listWordspotting: ({ commit }) => {
    return service.get()
      .then(data => {
        const wordspotting = {};
        ['global', 'org', 'user', 'groups'].forEach((type) => {
          wordspotting[type] = {};
          data[type].forEach((item) => {
            if (type === 'groups') {
              if (!(item.groupId in wordspotting.groups)) {
                wordspotting.groups[item.groupId] = {};
              }
              wordspotting.groups[item.groupId][item.algorithm] = item;
            } else {
              wordspotting[type][item.algorithm] = item;
            }
          });
        });
        commit(WORDSPOTTING_ALL, wordspotting);
        return data;
      })
      .catch(() => {}); // this will show an alert automatically
  },
  deleteWordspotting: ({ commit }, data) => {
    return service.delete(data)
      .then(() => {
        commit(WORDSPOTTING_DELETE, data);
      });
  },
  addWordspotting: ({ commit }, data) => {
    return service.post(data)
      .then(() => {
        commit(WORDSPOTTING_ADD, data);
      });
  },
};

const getters = {
  wordspotting: state => state.list,
};

export default {
  state,
  mutations,
  actions,
  getters
};
